/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Представление попапа товаров в корзине, у которых изменился остаток на складе.
   */
  app.CartRemainsPopupView = app.InfiniteScrollView.extend({
    additionalOptions: ['mainWindow', 'bodyView'],
    el: '.js-item-remains-popup',

    /** @inheritDoc */
    run: function () {
      this.initPopup();
      this.initLoader();
      this.itemTemplate = app.helpers.TemplateHelper.getTemplate('#cart-remains-popup-template');
      this.getScrollableList().on('scroll', this.onListScroll.bind(this));
    },

    /** @inheritDoc */
    initPopup: function () {
      if (!app.isMobile) {
        app.InfiniteScrollView.prototype.initPopup.call(this);
      } else if (typeof app.MobilePopupFillView !== 'undefined' ) {
        this.childViews.popupView = new app.MobilePopupFillView({
          el: this.$el,
          bodyView: this.bodyView,
          beforeOpen: function () {
            this.trigger('popup:before-open');
          }.bind(this)
        });
        this.popup = this.childViews.popupView.popup;
      }
    },

    /**
     * Инициализация прелоадера.
     */
    initLoader: function() {
      this.childViews.loader = new app.LoaderView({
        contentWrapper: app.isMobile ? this.$el : this.$el.find('.item-analogs-wrapper'),
        withFade: true,
        mainWindow: this.mainWindow,
        sizeClass: 'medium',
      });
    },

    /**
     * Выводит содержимое попапа.
     * @param {boolean} [needReRender] Булево значение. Показывает, необходимо ли перерисовать список.
     */
    render: function (needReRender) {
      if (needReRender) {
        this.clearList();
      }
      var $itemEl = $(this.itemTemplate({
        items: this.collection.toJSON(),
      }));
      this.getScrollableList().append($itemEl);
      this.childViews.loader.remove();
    },

    /**
     * Очищает список.
     */
    clearList: function () {
      this.getScrollableList().empty();
      this.getScrollableList().scrollTop(0);
    },
  });
})(jQuery);

}.call(window));